import {
  GetOutfitArgs,
  OutfitDetail,
  OutfitResult,
  ProductDetail,
  ProductDetailGrid,
  SearchResultStateType,
  VisualSearchArgs
} from "@type/index";
import { ActionsUnion, createAction } from "../helpers";

// save img page fetch result
export const FETCH_VISUAL_SERCH = "[SEARCH RESULT] FETCH VISUAL SERCH";
export const FETCH_VISUAL_SERCH_SUCCESS =
  "[SEARCH RESULT] FETCH VISUAL SERCH SUCCESS";
export const FETCH_PRODUCTS = "[SEARCH RESULT] FETCH PRODUCTS";
export const FETCH_OUTFITS = "[SEARCH RESULT] FETCH OUTFITS";
export const FETCH_PRODUCT_SUCCESS = "[SEARCH RESULT] FETCH PRODUCT SUCCESS";
export const FETCH_PRODUCT_SUCCESS_FOR_GA =
  "[SEARCH RESULT] FETCH PRODUCT SUCCESS FOR GA";
export const FETCH_OUTFIT_SUCCESS = "[SEARCH RESULT] FETCH OUTFIT SUCCESS";
export const CLEAR_OUTFIT = "[SEARCH RESULT] CLEAR OUTFIT";
export const SET_CATEGORY_TYPE = "[SEARCH RESULT] SET CATEGORY TYPE";
export const SET_PRODUCT_IDS = "[SEARCH RESULT] SET PRODUCT IDS";
export const SET_BOUNDS = "[SEARCH RESULT] SET BOUNDS";
export const SET_VISUAL_PRODUCTS = "[SEARCH RESULT] SET VISUAL PRODUCTS";
export const FETCH_FAVORITES_SEARCH = "[SEARCH RESULT] FETCH FAVORITES SEARCH";
export const FETCH_FAVORITES_SEARCH_SUCCESS =
  "[SEARCH RESULT] FETCH FAVORITES SEARCH SUCCESS";
export const FETCH_OUTFIT_FAVORITES_SEARCH =
  "[SEARCH RESULT] FETCH OUTFIT FAVORITES SEARCH";
export const FETCH_OUTFIT_FAVORITES_SEARCH_SUCCESS =
  "[SEARCH RESULT] FETCH OUTFIT FAVORITES SEARCH SUCCESS";
export const SET_FAVORITE_SUCCESS = "[SEARCH RESULT] SET FAVORITE SUCCESS";
export const SET_OUTFIT_FAVORITE = "[SEARCH RESULT] SET OUTFIT FAVORITE";
export const SET_OUTFIT_FAVORITE_SUCCESS =
  "[SEARCH RESULT] SET OUTFIT FAVORITE SUCCESS";
export const SET_ITEM_LOADING_STATUS = "[SEARCH RESULT] SET LOADING STATUS";
export const SET_OUTFIT_LOADING_STATUS =
  "[SEARCH RESULT] SET OUTFIT LOADING STATUS";
export const SET_OUTFIT_HAS_NEXT_PAGE_LOADING_STATUS =
  "[SEARCH RESULT] SET OUTFIT HAS NEXT PAGE LOADING STATUS";
export const SET_PRODUCT_ITEM_ID = "[SEARCH RESULT] SET PRODUCT ITEM ID";
export const SET_OUTFIT_HAS_MORE = "[SEARCH RESULT] SET OUTFIT HAS MORE";
export const SET_VISUAL_SEARCH_NO_DATA =
  "[SEARCH RESULT] SET VISUAL SEARCH NO DATA";
export const SET_CHANGE_ITEM_FILTER_FLAG =
  "[SEARCH RESULT] SET IS ERROR BY CHANGE ITEM FILTER";
export const SET_CHANGE_ITEM_SORT_FLAG =
  "[SEARCH RESULT] SET IS ERROR BY CHANGE ITEM SORT";
export const SET_CHANGED_ITEM_FILTER_SORT_ERROR =
  "[SEARCH RESULT] SET_CHANGED_ITEM_FILTER_SORT_ERROR";
export const SET_CHANGE_OUTFIT_FILTER_FLAG =
  "[SEARCH RESULT] SET IS ERROR BY CHANGE OUTFIT FILTER";
export const SET_CHANGE_OUTFIT_SORT_FLAG =
  "[SEARCH RESULT] SET IS ERROR BY CHANGE OUTFIT SORT";
export const SET_CHANGED_OUTFIT_FILTER_SORT_ERROR =
  "[SEARCH RESULT] SET_CHANGED_OUTFIT_FILTER_SORT_ERROR";

export const Actions = {
  fetchVisualSearch: (payload: VisualSearchArgs): any =>
    createAction(FETCH_VISUAL_SERCH, payload),
  fetchProducts: (payload: any): any => createAction(FETCH_PRODUCTS, payload),
  fetchOutfits: (payload: GetOutfitArgs): any =>
    createAction(FETCH_OUTFITS, payload),
  fetchFavoritesSearch: (payload: any): any =>
    createAction(FETCH_FAVORITES_SEARCH, payload),
  fetchOutfitFavoritesSearch: (payload: any): any =>
    createAction(FETCH_OUTFIT_FAVORITES_SEARCH, payload),
  setCategoryType: (type: string): any => createAction(SET_CATEGORY_TYPE, type),
  setProductIds: (productIds: string[]): any =>
    createAction(SET_PRODUCT_IDS, productIds),
  setBounds: (bounds: any[]): any => createAction(SET_BOUNDS, bounds),
  setVisualProducts: (visualProducts: any[]): any =>
    createAction(SET_VISUAL_PRODUCTS, visualProducts),
  setFavoriteSuccess: (payload: ProductDetail): any =>
    createAction(SET_FAVORITE_SUCCESS, payload),
  setOutfitFavorite: (payload: OutfitDetail): any =>
    createAction(SET_OUTFIT_FAVORITE, payload),
  setOutfitFavoriteSuccess: (payload: OutfitDetail): any =>
    createAction(SET_OUTFIT_FAVORITE_SUCCESS, payload),
  setProductItemIds: (ids: string[]): any =>
    createAction(SET_PRODUCT_ITEM_ID, ids),
  fetchProductsSuccess: (payload: any): any =>
    createAction(FETCH_PRODUCT_SUCCESS, payload),
  fetchProductsSuccessForGa: (payload: any): any =>
    createAction(FETCH_PRODUCT_SUCCESS_FOR_GA, payload),
  fetchOutfitsSuccess: (result: OutfitResult): any =>
    createAction(FETCH_OUTFIT_SUCCESS, result),
  clearOutfits: (): any => createAction(CLEAR_OUTFIT),
  fetchFavoritesSearchSuccess: (payload: any): any =>
    createAction(FETCH_FAVORITES_SEARCH_SUCCESS, payload),
  fetchOutfitFavoritesSearchSuccess: (payload: any): any =>
    createAction(FETCH_OUTFIT_FAVORITES_SEARCH_SUCCESS, payload),
  setItemLoadingStatus: (status: boolean): any =>
    createAction(SET_ITEM_LOADING_STATUS, status),
  setOutfitLoadingStatus: (status: boolean): any =>
    createAction(SET_OUTFIT_LOADING_STATUS, status),
  setOutfitHasNextPageLoadingStatus: (status: boolean): any =>
    createAction(SET_OUTFIT_HAS_NEXT_PAGE_LOADING_STATUS, status),
  setOutfitHasMore: (payload: boolean): any =>
    createAction(SET_OUTFIT_HAS_MORE, payload),
  setProductsNoData: (payload: boolean): any =>
    createAction(SET_VISUAL_SEARCH_NO_DATA, payload),
  setChangedItemFilterFlag: (payload: boolean): any =>
    createAction(SET_CHANGE_ITEM_FILTER_FLAG, payload),
  setChangedItemSortFlag: (payload: boolean): any =>
    createAction(SET_CHANGE_ITEM_SORT_FLAG, payload),
  setChangedItemFilterSortError: (payload: boolean): any =>
    createAction(SET_CHANGED_ITEM_FILTER_SORT_ERROR, payload),
  setChangedOutfitFilterFlag: (payload: boolean): any =>
    createAction(SET_CHANGE_OUTFIT_FILTER_FLAG, payload),
  setChangedOutfitSortFlag: (payload: boolean): any =>
    createAction(SET_CHANGE_OUTFIT_SORT_FLAG, payload),
  setChangedOutfitFilterSortError: (payload: boolean): any =>
    createAction(SET_CHANGED_OUTFIT_FILTER_SORT_ERROR, payload)
};

type ActionType = ActionsUnion<typeof Actions>;

const initialState: SearchResultStateType = {
  result: {
    aggregations: {
      colors: [],
      flags: [],
      plds: [],
      prices: [],
      ratings: [],
      sizes: [],
      tree: {}
    },
    pagination: {
      count: 0
    },
    items: [] as ProductDetailGrid[],
    initFlag: true
  },
  resultForGa: {
    aggregations: {
      colors: [],
      flags: [],
      plds: [],
      prices: [],
      ratings: [],
      sizes: [],
      tree: {}
    },
    pagination: {
      count: 0
    },
    items: [] as ProductDetailGrid[],
    initFlag: true
  },
  searchImage: "",
  productIds: [],
  categoryType: "",
  bounds: [],
  visualProducts: [],
  // outfit
  productItemIds: [],
  outFitResult: {
    offset: 0,
    total: 0,
    similarOutfits: []
  },
  backupOutFitResult: {
    offset: 0,
    total: 0,
    similarOutfits: []
  },
  resultItemloading: false,
  visibleOutfitloading: false,
  visibleOutfitHasNextPageLoading: false,
  outfitHasMore: true,
  visualSearchNoData: false,
  isChangedItemFilterFlag: false,
  isChangeItemSortFlag: false,
  isFilterSortItemError: false,
  isChangedOutfitFilterFlag: false,
  isChangeOutfitSortFlag: false,
  isFilterSortOutfitError: false
};

export default (
  state: SearchResultStateType = initialState,
  action: ActionType
): SearchResultStateType => {
  switch (action.type) {
    case FETCH_PRODUCT_SUCCESS: {
      return { ...state, result: action.payload, resultItemloading: false };
    }
    case FETCH_PRODUCT_SUCCESS_FOR_GA: {
      return {
        ...state,
        resultForGa: action.payload,
        resultItemloading: false
      };
    }
    case FETCH_OUTFIT_SUCCESS: {
      const newOutfitResult: OutfitResult = action.payload;
      // fixme: 请求过程中出错 重新获取会是下一个page
      if (action.payload.offset > 0) {
        newOutfitResult.similarOutfits = [
          ...state.outFitResult.similarOutfits,
          ...action.payload.similarOutfits
        ];
      }
      return {
        ...state,
        outFitResult: newOutfitResult,
        backupOutFitResult: { ...newOutfitResult },
        visibleOutfitloading: false,
        visibleOutfitHasNextPageLoading: false
      };
    }
    case CLEAR_OUTFIT: {
      const emptyOutfits: OutfitResult = {
        offset: 0,
        total: 0,
        similarOutfits: []
      };
      return {
        ...state,
        outFitResult: { ...emptyOutfits }
      };
    }
    case SET_FAVORITE_SUCCESS: {
      const product: ProductDetail = action.payload;
      const result: any = state.result;
      result.items.forEach((item: ProductDetail, index: number) => {
        if (item.productId === product.productId) {
          result.items[index].favorite = !product.favorite;
        }
      });
      return { ...state, result: { ...result } };
    }
    case SET_OUTFIT_FAVORITE_SUCCESS: {
      const outfit: OutfitDetail = action.payload;
      const outFitResult: any = state.outFitResult;
      outFitResult.similarOutfits.forEach(
        (item: OutfitDetail, index: number) => {
          if (item.styleId === outfit.styleId) {
            outFitResult.similarOutfits[index].favorite = !outfit.favorite;
          }
        }
      );
      return { ...state, outFitResult: { ...outFitResult } };
    }

    case SET_CATEGORY_TYPE: {
      return { ...state, categoryType: action.payload };
    }
    case SET_PRODUCT_IDS: {
      return { ...state, productIds: action.payload };
    }
    case SET_BOUNDS: {
      return { ...state, bounds: action.payload };
    }
    case SET_VISUAL_PRODUCTS: {
      return { ...state, visualProducts: action.payload };
    }
    case SET_ITEM_LOADING_STATUS: {
      return { ...state, resultItemloading: action.payload };
    }
    case SET_OUTFIT_LOADING_STATUS: {
      return { ...state, visibleOutfitloading: action.payload };
    }
    case SET_OUTFIT_HAS_NEXT_PAGE_LOADING_STATUS: {
      return { ...state, visibleOutfitHasNextPageLoading: action.payload };
    }
    case SET_PRODUCT_ITEM_ID: {
      return { ...state, productItemIds: action.payload };
    }
    case SET_OUTFIT_HAS_MORE: {
      return { ...state, outfitHasMore: action.payload };
    }
    case SET_VISUAL_SEARCH_NO_DATA: {
      return { ...state, visualSearchNoData: action.payload };
    }
    case SET_CHANGE_ITEM_FILTER_FLAG: {
      return {
        ...state,
        isChangedItemFilterFlag: action.payload,
        isChangeItemSortFlag: !action.payload
      };
    }
    case SET_CHANGE_ITEM_SORT_FLAG: {
      return {
        ...state,
        isChangeItemSortFlag: action.payload,
        isChangedItemFilterFlag: !action.payload
      };
    }
    case SET_CHANGED_ITEM_FILTER_SORT_ERROR: {
      return { ...state, isFilterSortItemError: action.payload };
    }
    case SET_CHANGE_OUTFIT_FILTER_FLAG: {
      return {
        ...state,
        isChangedOutfitFilterFlag: action.payload,
        isChangeOutfitSortFlag: !action.payload
      };
    }
    case SET_CHANGE_OUTFIT_SORT_FLAG: {
      return {
        ...state,
        isChangeOutfitSortFlag: action.payload,
        isChangedOutfitFilterFlag: !action.payload
      };
    }
    case SET_CHANGED_OUTFIT_FILTER_SORT_ERROR: {
      if (action.payload) {
        return {
          ...state,
          isFilterSortOutfitError: action.payload,
          outFitResult: state.backupOutFitResult
        };
      }
      return { ...state, isFilterSortOutfitError: action.payload };
    }
    default:
      return state;
  }
};
